import React, { useEffect, useState } from "react";
import { DollarSign, ShoppingBag, Clock, Users, Mail, Package } from "lucide-react";
import { fetchStats } from "../../lib/api";

const Stat = ({ icon: I, label, value, testId }) => (
  <div className="glass-navy-card rounded-2xl p-5" data-testid={testId}>
    <div className="flex items-center justify-between">
      <p className="text-slate-400 text-xs uppercase tracking-wider">{label}</p>
      <span className="h-9 w-9 rounded-lg bg-gold/10 border border-gold/30 flex items-center justify-center text-gold"><I size={16} /></span>
    </div>
    <p className="mt-3 text-2xl font-display font-bold text-white">{value}</p>
  </div>
);

const OverviewPanel = ({ goTo }) => {
  const [s, setS] = useState(null);
  useEffect(() => { fetchStats().then(setS).catch(() => {}); }, []);
  if (!s) return <div className="text-slate-400">Loading overview...</div>;
  const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

  return (
    <div className="space-y-8" data-testid="admin-overview">
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        <Stat icon={DollarSign} label="Paid Revenue" value={money(s.revenue)} testId="stat-revenue" />
        <Stat icon={Clock} label="Awaiting Payment" value={money(s.pendingValue)} testId="stat-pending" />
        <Stat icon={ShoppingBag} label="Total Orders" value={s.orders} testId="stat-orders" />
        <Stat icon={Users} label="Customers" value={s.customers} testId="stat-customers" />
        <Stat icon={Package} label="Products" value={s.products} testId="stat-products" />
        <Stat icon={Mail} label="Unread Messages" value={s.unreadMessages} testId="stat-messages" />
      </div>

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 glass-navy-card rounded-2xl p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-white font-bold">Recent Orders</h3>
            <button onClick={() => goTo("orders")} className="text-gold text-sm hover:underline" data-testid="overview-view-orders">View all</button>
          </div>
          {s.recent.length === 0 ? <p className="text-slate-500 text-sm">No orders yet.</p> : (
            <div className="divide-y divide-white/5">
              {s.recent.map((o) => (
                <div key={o.orderId} className="flex items-center justify-between py-3 text-sm">
                  <div><p className="text-gold font-semibold">{o.orderId}</p><p className="text-slate-400 text-xs">{o.name} · {o.createdAt ? new Date(o.createdAt).toLocaleDateString() : ""}</p></div>
                  <div className="text-right"><p className="text-white font-semibold">{money(o.total)}</p><p className="text-slate-400 text-xs capitalize">{o.status}</p></div>
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="glass-navy-card rounded-2xl p-6">
          <h3 className="text-white font-bold mb-4">Orders by Status</h3>
          {["pending", "paid", "shipped", "delivered", "cancelled"].map((k) => {
            const n = s.byStatus[k] || 0;
            const pct = s.orders ? Math.round((n / s.orders) * 100) : 0;
            return (
              <div key={k} className="mb-3">
                <div className="flex justify-between text-xs mb-1"><span className="text-slate-300 capitalize">{k}</span><span className="text-slate-400">{n}</span></div>
                <div className="h-2 rounded-full bg-navy-700 overflow-hidden"><div className="h-full btn-liquid rounded-full" style={{ width: `${pct}%` }} /></div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default OverviewPanel;
